import React, { useRef, useEffect, memo } from 'react';
import type { FunctionComponent, ReactNode } from 'react';
import { Modal as CasModal } from '@web-components-proxy';
import { JSX } from '@caspio/components';

import './Modal.scss';

export interface ModalProps extends Partial<JSX.CasModal> {
	isOpen: boolean;
	children: ReactNode;
	className?: string;
}

export const Modal: FunctionComponent<ModalProps> = memo(({ isOpen, children, ...otherProps }) => {
	const modalRef = useRef<HTMLCasModalElement | null>(null);

	useEffect(() => {
		const modal = modalRef.current;
		if (!modal) return;

		if (isOpen) {
			modal.open();
		} else {
			modal.hide();
		}

		return () => {
			modal.hide();
		};
	}, [isOpen]);

	return (
		<CasModal
			{...otherProps}
			ref={modalRef}
			onCasClosed={otherProps.onCasClosed}
			className="modal-wrapper"
			templateMode
		>
			{children}
		</CasModal>
	);
});
